import React, { Component } from 'react';
import Poll from 'material-ui/svg-icons/social/poll';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import ResultTrend from './ResultTrend';

import getScoreClass from '../modules/scoreclass';

class ResultHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleDialogOpen = () => {
    this.setState({ open: true });
  }

  handleDialogClose = () => {
    this.setState({ open: false });
  }

  renderResult = (result, index) => {
    const score = parseInt(result.score, 10) || 0;
    const scoreClass = getScoreClass(score);

    const style = {
      width: `calc(${score}% - 20px)`,
    };
    return (
      <tr className="pronounce-results-row" key={index}>
        <td>{result.result.result}</td>
        <td className="pronounce-results-score-indicator-wrapper"><span style={style} className={`pronounce-results-score-indicator ${scoreClass}`}>&nbsp;</span>&nbsp;{score}</td>
      </tr>
    );
  }

  render() {
    const tries = this.props.resultHistory.length;

    const disabled = this.props.text.length === 0 || this.props.resultHistory.length === 0;

    const actions = [
      <FlatButton
        label="Close"
        primary
        onTouchTap={this.handleDialogClose}
      />,
    ];

    return (
      <div className="pronounce-result-history">
        <IconButton title="View result history" disabled={disabled} onClick={this.handleDialogOpen}>
          <Poll />
        </IconButton>
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleDialogClose}
          autoScrollBodyContent
        >
          <h4>Original phrase:</h4>
          <h3>{this.props.text}</h3>
          <hr />
          <h4>You've tried it {tries} times</h4>
          <h4>Result trend</h4>
          <ResultTrend resultHistory={this.props.resultHistory} />
          <h4>Result history</h4>
          <table className="pronounce-results-table">
            <tbody>
              {this.props.resultHistory.map((result, index) => this.renderResult(result, index)) }
            </tbody>
          </table>
        </Dialog>
      </div>
    );
  }
}

export default ResultHistory;



// WEBPACK FOOTER //
// ./src/components/ResultHistory.js